import React from 'react';
import { Radio, Segment } from 'semantic-ui-react';
import styled from 'styled-components';

import { ProjectClass } from '@/types/projectClass';
import { Service } from '@/types/service';

export type Props = {
  selected: number | undefined;
  list: Array<Service | ProjectClass>;
  onChange: (serviceId: number, checked: boolean) => void;
};

export const RadioButtons: React.FC<Props> = ({ list, selected, onChange }) => (
  <Styled>
    <div className="services">
      {list.map((item, i) => {
        const checked = selected === item.id;

        return (
          <label
            data-test={`service-${i}`}
            htmlFor={`service-${item.id}`}
            key={item.id}
          >
            <Segment className={checked ? 'service active' : 'service'}>
              <Radio
                checked={checked}
                id={`service-${item.id}`}
                label={item.name}
                name="service"
                value={item.id}
                onChange={(e, data) => {
                  onChange(item.id, !!data.checked);
                }}
                radio={true}
              />
            </Segment>
          </label>
        );
      })}
    </div>
  </Styled>
);

const Styled = styled.div`
  .services {
    display: flex;
    flex-flow: column;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 0;
  }

  .services > label {
    width: 100%;
    white-space: nowrap;
    margin-bottom: 0.75em !important;
  }

  .ui.segment.service {
    cursor: pointer;
  }

  .ui.segment.service.active {
    border: 1px solid #2185d0;
    background-color: #f1f9ff;
  }
`;
